import React from "react";
import { useParams, Link } from "react-router-dom";
import { EvtHeader } from "components/header";
import { useFetch } from "@/hooks/useFetch";
import { fetchExtension } from "@/modules/work/jobs/extensions/read";
import { useUpdateExtension } from "@/modules/work/jobs/extensions/update/mutation";
import ExtensionForm from "@/modules/work/jobs/extensions/form";
import { StatusDisplay } from "@/components/status/display";
import { PermissionGate } from "permissions/components/gate";
import ButtonWithLoading from "@/components/button-with-loading";
import Loader from "@/components/loader";
import ErrorState from "@/components/states/error";
import HeaderPortal from "components/portal/header-portal";
import UpdateItemButton from "components/buttons/update"
import BillableJobsBanner from "./billable-banner";

export default function ExtensionDetail() {
  const { jobId, extensionId } = useParams();
  const updateExtensionMutation = useUpdateExtension();

  const { data: extension, isLoading, error } = useFetch({
    queryKey: ["job_extensions", extensionId],
    queryFn: () => fetchExtension({ id: extensionId }),
  });

  const handleApprove = async () => {
    await updateExtensionMutation.mutateAsync({
      id: extensionId,
      values: { status: "approved" },
    });
  };

  if (isLoading) return <Loader />;
  if (error) return <ErrorState title="Error loading extension" message={error?.message} />;
  if (!extension) return null;

  // Only show action buttons while the request is still pending
  const isPending = extension.status === "pending";

  return (
    <div className="flex-1">
      {isPending &&
        <>
          <BillableJobsBanner />
          <HeaderPortal>
            <PermissionGate collection="job_extensions" rule="update:JC,AM">
              <UpdateItemButton href />
            </PermissionGate>
          </HeaderPortal>
        </>
      }
      <EvtHeader
        title="Extension Request"
        description={
          extension.status ? <StatusDisplay value={extension.status} /> : null
        }
      />
      <div className="p-6 max-w-md space-y-6">
        <ExtensionForm
          jobId={jobId}
          extensionId={extensionId}
          defaultValues={extension}
          readOnly
        />
        {isPending && (
          <PermissionGate collection="job_extensions" rule="update:AM">
            <ButtonWithLoading
              variant="default"
              isLoading={updateExtensionMutation.isPending}
              onClick={handleApprove}
            >
              Approve Request
            </ButtonWithLoading>
          </PermissionGate>
        )}
      </div>
    </div>
  );
}
